import { DatePicker } from "../../../core/components/datePicker";
import { Dialog, DialogProps } from "../../../core/components/dialog";
import { DropDownList } from "../../../core/components/dropDownList";
import { FieldInstance } from "../../../core/components/field";
import { TextBox } from "../../../core/components/textBox";
import { Config } from "../../../core/config/config";
import { ComponentHelper } from "../../../core/util/componentHelper";
import { Helper } from "../../../core/util/helper";
import { NotificationHelper } from "../../../core/util/notificationHelper";
import React from "react";
import ReactDOM from "react-dom";

export const OpenInternalCurrencyDialog = (sourceCurrency: InternalCurrency = null) => {
    return new Promise<InternalCurrency>((resolve) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (currency: InternalCurrency) => {
                resolve(currency)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            },
            currency: sourceCurrency,
            editExisting: Helper.hasValue(sourceCurrency),
            isMainGroup: false
        }
        $("body").append(targetElement);
        ReactDOM.render(<InternalCurrencyDialog {...props} />, targetElement[0]);
    })
}

export const OpenMainGroupInternalCurrencyDialog = (idCurr: number, sourceCurrency: InternalCurrency = null) => {
    return new Promise<InternalCurrency>((resolve) => {
        const targetElement = $("<div>");
        const props: any = {
            onOk: (currency: InternalCurrency) => {
                resolve(currency)
            },
            onCancel: () => {
                ReactDOM.unmountComponentAtNode(targetElement[0]);
                targetElement[0].remove();
            },
            currency: sourceCurrency,
            editExisting: Helper.hasValue(sourceCurrency),
            idCurr: idCurr,
            isMainGroup: true
        }
        $("body").append(targetElement);
        ReactDOM.render(<InternalCurrencyDialog {...props} />, targetElement[0]);
    })
}

class InternalCurrencyDialog extends React.Component<{
    onOk: (currency: InternalCurrency) => void;
    onCancel: () => void;
    currency: InternalCurrency;
    editExisting: boolean;
    idCurr: number;
    isMainGroup: boolean;
}, {
    from: Date,
    to: Date,
    currency: string,
    name: string
}>{
    private _factory = ComponentHelper.createFactory();
    private _dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => { }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    if (this.checkCurrency()) {
                        this.onOk();
                    }
                    else {
                        NotificationHelper.showErrorMessage(Helper.getTranslation("Standard.PflichtfeldAllgemein"));
                        return false;
                    }
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.props.onCancel();
        },
        width: 500
    };

    private checkCurrency = () => {
        return Helper.hasValue(this.state.from) && Helper.hasValue(this.state.to) && !Helper.isNullOrEmpty(this.state.currency);
    }

    constructor(props) {
        super(props);
        this.state = {
            from: this.props.currency?.From,
            to: this.props.currency?.To,
            currency: this.props.currency?.Currency,
            name: this.props.currency?.Name
        }
    }

    private onOk = () => {
        let currency: InternalCurrency = {
            Currency: this.state.currency,
            From: this.state.from,
            To: this.state.to,
            Name: this.state.name
        };
        this.props.onOk(currency);
    }

    private createDropDownList = () => {
        let url = "GeneralSettingsCurrency/GetDistinctCurrenciesList";
        if (Helper.hasValue(this.props.idCurr))
            url = "GeneralSettingsCurrency/GetDistinctCurrenciesList?idCurr=" + encodeURIComponent(this.props.idCurr);
        let props = this._factory.getDefaultDropDownProps();
        props.value = this.state.currency ?? "";
        props.field.dataSourceUrl = url;
        props.field.template = "<table cellspacing='0' style='table-layout:fixed; width:290px'><colgroup><col style='width: 60px' /><col style='width: 200px' /><col style='width: 30px' /></colgroup><tr style='background-color:inherit'><td style='vertical-align:top'>${data.Currency}</td><td style='vertical-align:top'>${data.Bezeichnung}</td><td style='vertical-align:top'>${data.Zeichen}</td></tr></table>"
        props.field.dataTextField = "Bezeichnung";
        props.field.dataValueField = "Currency";
        props.field.required = true;
        props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
            this.setState({ currency: value });
        }
        return (
            <FieldInstance label={Helper.getTranslation("WebSMS.GeneralSettings.Currency.Currency") + "*"} noHover={true}>
                <DropDownList {...props} />
            </FieldInstance>
        );
    }

    private createDatePicker = (type: "from" | "to") => {
        let props = this._factory.getDefaultDatePickerProps();
        let labelCode: string;
        if (type == "from") {
            props.value = this.state.from;
            labelCode = "Standard.Von";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                this.setState({ from: value });
            };
        } else {
            props.value = this.state.to;
            labelCode = "Standard.Bis";
            props.onChange = (field: { model: string }, value: any, dataItem?: any) => {
                this.setState({ to: value });
            };
        }
        return (
            <FieldInstance label={Helper.getTranslation(labelCode) + "*"} noHover={true}>
                <DatePicker {...props} />
            </FieldInstance>
        );
    }

    private createTextBox = () => {
        let props = this._factory.getDefaultTextBoxProps();
        props.value = this.state.name;
        props.onChange = (_, value) => this.setState({ name: value });

        if (!this.props.isMainGroup)
            return null;

        return <FieldInstance label={"Name"} noHover={true}>
            <TextBox {...props } />
        </FieldInstance>;
    }

    render() {
        return (<>
            <div>
                <Dialog {...this._dialogProps} open={true}>
                    {this.createDropDownList()}
                    {this.createDatePicker("from")}
                    {this.createDatePicker("to")}
                    {this.createTextBox()}
                </Dialog>
            </div>
        </>)
    }
}

export interface InternalCurrency {
    Id?: number;
    Currency?: string;
    From?: Date;
    To?: Date;
    GUID?: string;
    IsNew?: boolean;
    IsDeletable?: boolean;
    IsCurrent?: boolean;
    Name?: string;
}